import type { App } from "vue";
import ElementPlus from "element-plus";
import type { ConfigProviderProps } from "element-plus";
import "element-plus/dist/index.css";
import "element-plus/theme-chalk/dark/css-vars.css";
import * as ElementPlusIconsVue from "@element-plus/icons-vue";
import zhCn from "element-plus/dist/locale/zh-cn.mjs";

/**
 * Element Plus 全局配置
 * @type {Partial<ConfigProviderProps>}
 */
const elementPlusConfig: Partial<ConfigProviderProps> = {
  /**
   * 组件尺寸配置
   */
  size: "default",

  /**
   * 组件 z-index 层级
   */
  zIndex: 2000,

  /**
   * 组件类名前缀
   */
  namespace: "el",

  /**
   * 按钮配置
   */
  button: {
    /**
     * 自动在两个中文字符之间插入空格
     */
    autoInsertSpace: false,
  },
  /**
   * 国际化配置
   */
  locale: zhCn,
};

/**
 * 设置 Element Plus 插件
 * @param app - Vue 应用实例
 */
export function setupElementPlus(app: App): void {
  // 注册 Element Plus
  app.use(ElementPlus, elementPlusConfig);

  // 注册所有图标
  for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component);
  }
}
